import { formatNumber } from '@agro1desenvolvimento/utils-js';
import { ItemSaldo } from '../../@types';

const NUMBER_FORMAT_OPTIONS = {
  maximumFractionDigits: 4,
  useGrouping: true,
};

const ItemSaldoOptionTemplate = (option: ItemSaldo) => {
  const saldoFisico = formatNumber(option.saldoFisico, NUMBER_FORMAT_OPTIONS);
  const saldoReceber = formatNumber(option.saldoReceber, NUMBER_FORMAT_OPTIONS);
  const saldoEmUso = formatNumber(option.saldoEmUso, NUMBER_FORMAT_OPTIONS);

  return (
    <div className="item-saldo-option-template">
      <div>{option.descricao}</div>
      <div className="dropdown-item-saldo-container">
        <p className="dropdown-item-saldo">
          Físico: {saldoFisico} {option.unidade.abreviatura}
        </p>
        <p className="dropdown-item-saldo">
          A receber: {saldoReceber} {option.unidade.abreviatura}
        </p>
        <p className="dropdown-item-saldo">
          Em uso: {saldoEmUso} {option.unidade.abreviatura}
        </p>
      </div>
    </div>
  );
};

export default ItemSaldoOptionTemplate;
